<template>
    <div>
        <video autoplay muted loop id="myVideo">
            <source src="https://alfiobardolla.com/video/video-per-nuovo-sito.mp4" type="video/mp4" style="width:100%;">
        </video>
        <div class="limiter">
            <!-- The video -->


            <!-- Optional: some overlay text to describe the video -->

            <div class="container-login100 ">
                <div class="wrap-login100">

                        <span class="login100-form-title p-b-34 p-t-27">
						<img src="/img/logo_abtool_bianco.svg" width="200">
					</span>
                    <p style="color:white" class="text-center">Il sito è in fase di aggiornamento. <br>Presto sarà nuovamente disponibile.</p>
                    <p style="color:white" class="text-center">Il team di REP</p>







                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {mixin} from '../../helpers/helper'
    import {Money} from 'v-money';
    import {createHelpers} from 'vuex-map-fields';

    const {mapFields} = createHelpers({
        getterType: 'user/getField',
        mutationType: 'user/updateField',
    });

    export default {
        mixins: [mixin],
        components: {Money},
        data: function () {
            return {
                email: '',
                password: '',

            }
        },

        computed: {
            ...mapFields(['errorMsg', 'stepLogin']),
        },
        created: function () {
            this.isRemembered();
        },
        methods: {
            onSubmit: function () {
                this.$store.dispatch('user/checkLogin', {
                    email: this.email,
                    password: this.password
                })
            },

            isRemembered: function()
            {
                this.$store.dispatch('user/isRemembered');
            }
        }
    }
</script>